import '../estilo/media-youtube.scss'
import * as comun from './modulos/comun'
import articulus from './modulos/articulus'

comun.registrarServiceWorker().catch(error => { console.error(error) })
comun.chorrear(() => {
  comun.iniciarMenu('mnuMedia')
})

//
let url
let esperando = false
let escuchandoScroll = false
let pagina = 1
let busqueda = ''

// Menu media
url = `${comun.urlBaseApi}/apis/articulus/v1/blogs/blog_orsai_es/media-titulos?tipo=youtube&cache=0`
articulus(url, 'es').then(titulosMedia => {
  let linksMenu = '<a href="#">Todos</a>'
  titulosMedia.forEach(titMedia => { linksMenu += `<a href="#">${titMedia}</a>` })
  document.querySelector('.menuMedia').innerHTML = linksMenu
}).catch(error => { console.log(error) })

//
document.querySelector('.menuMedia').addEventListener('click', evento => {
  evento.preventDefault()
  if (evento.target.tagName == 'A') {
    // Resalta enlace
    let enlaces = document.querySelectorAll('.menuMedia a')
    for ( let enlace of enlaces ) enlace.classList.remove('actual')
    evento.target.classList.add('actual')
    // Usa título de media para filtrar
    busqueda = evento.target.textContent
    busqueda = busqueda == 'Todos' ? '' : busqueda
    // Actualiza título de página
    document.querySelector('h1 .filtro').textContent = busqueda ? busqueda : 'YouTube'
    // Limpia contenedor de artículos
    let items = document.querySelectorAll('.mediaArtis .mediaArti')
    for ( let item of items ) document.querySelector('.mediaArtis').removeChild( item )
    // Elimina pie de página
    document.querySelector('.piePagina').innerHTML = ''
    // Resetea variables
    pagina = 1
    esperando = false
    //
    mostrarPrimeraPagina()
  }
})

function mostrarPrimeraPagina() {
  // Muestra primera página y se queda escuchando el evento scroll para mostrar las demás
  url = `${comun.urlBaseApi}/apis/articulus/v1/blogs/blog_orsai_es/articulos-full/?media=1&orden=crono&ordenDir=desc&pag=${pagina}&porPag=6&incEtiquetas=1&tipoMedia=youtube&busquedaMedia=${busqueda}&cache=0`
  articulus(url, 'es').then(resArtis => {
    // Cantidad de artículos en el título de la página
    document.querySelector('h1 .totalArtis').textContent = resArtis.paginacion.totalArtis
    if (resArtis.paginacion.totalArtis !== 1) document.querySelector('h1 .plural').classList.remove('oculto')
    else document.querySelector('h1 .plural').classList.add('oculto')
    //
    mostrarArticulos(resArtis.articulos)
    if (pagina != resArtis.paginacion.total) { // Si no es la única página de resultados
      if (!escuchandoScroll) {
        escuchandoScroll = true
        window.addEventListener('scroll', () => {
          // Si scroll cerca del pie de página y no se está esperando respuesta de la API
          if (document.body.scrollHeight - (window.innerHeight + window.scrollY) < 300 && !esperando) {
            pagina ++ // Página siguiente a mostrar
            esperando = true
            document.querySelector('.capaLoader').classList.remove('oculto')
            url = `${comun.urlBaseApi}/apis/articulus/v1/blogs/blog_orsai_es/articulos-full/?media=1&orden=crono&ordenDir=desc&pag=${pagina}&porPag=6&incEtiquetas=1&tipoMedia=youtube&busquedaMedia=${busqueda}&cache=0`
            articulus(url, 'es').then(resArtis => {
              mostrarArticulos(resArtis.articulos)
              if (pagina == resArtis.paginacion.total) mostrarPiePagina()
              else esperando = false
              document.querySelector('.capaLoader').classList.add('oculto')
            }).catch(error => { console.log(error) })
          }
        })
      }
    } else {
      esperando = true // Para no repetir peticiones on scroll
      mostrarPiePagina()
    }
  }).catch(error => { console.log(error) })
}

mostrarPrimeraPagina()

function mostrarArticulos(artis) {
  if (artis.length > 0) {
    let articulo
    artis.forEach(arti => {
      articulo = document.querySelector('.plantilla.mediaArti').cloneNode(true)
      articulo.querySelector('.titulo').textContent = arti.tituloArticulo
      articulo.querySelector('.titulo').href = `/blog/${arti.tituloUrl}`
      articulo.querySelector('.video iframe').src = `https://www.youtube.com/embed/${arti.idMedia}`
      // Etiquetas
      const nombresEtiq = arti.nombresEtiq.split(',')
      const nombresBaseEtiq = arti.nombresBaseEtiq.split(',')
      const cantidadArtisEtiq = arti.cantidadArtisEtiq.split(',')
      let aEtiquetas = []
      for (let i = 0; i < nombresEtiq.length; i++) { // Pone datos de etiquetas en un solo array
        aEtiquetas.push({ nombre: nombresEtiq[i], nombreBase: nombresBaseEtiq[i], cantidadArtis: parseInt(cantidadArtisEtiq[i], 10) })
      }
      aEtiquetas.sort((a,b) => { // Ordena etiquetas por cantidad de artículos descendente
        return (a.cantidadArtis < b.cantidadArtis) ? 1 : ((b.cantidadArtis < a.cantidadArtis) ? -1 : 0)
      })
      let etiqHref
      let etiquetas = ''
      let etiqValidas = 0 // Con más de un artículo
      for (let i = 0; i < aEtiquetas.length; i++) {
        if (aEtiquetas[i].cantidadArtis > 1) {
          etiqHref = `/blog/etiqueta/${aEtiquetas[i].nombreBase}`
          etiquetas += `<a href="${etiqHref}"><span class="nombresEtiq">${aEtiquetas[i].nombre}</span><span class="cantidadArtisEtiq">${aEtiquetas[i].cantidadArtis}</span></a>`
          etiqValidas ++
        }
        if (etiqValidas > 5) break // Se muestran hasta 6 etiquetas
      }
      articulo.querySelector('.etiquetas').innerHTML = etiquetas
      //
      document.querySelector('.mediaArtis').appendChild(articulo) // Agrega plantilla al contenedor
      articulo.classList.remove('plantilla') // y la hace visible
    })
  }
}

//
function mostrarPiePagina () {
  fetch('/piePagina.html', { method: 'get' })
  .then(res => res.text())
  .then(resTexto => {
    document.querySelector('.piePagina').innerHTML = resTexto
    comun.chorrear()
  }).catch(error => { console.error(error) })
}
